'use strict';

window.CUSTOMIZER_POSITIONS = {
  front:            { x: 0.25, y: 0.20, w: 0.50, h: 0.40 },
  back:             { x: 0.25, y: 0.15, w: 0.50, h: 0.45 },
  left_chest:       { x: 0.55, y: 0.20, w: 0.20, h: 0.15 },
  right_sleeve:     { x: 0.10, y: 0.25, w: 0.15, h: 0.20 },
  left_sleeve:      { x: 0.75, y: 0.25, w: 0.15, h: 0.20 },
  // Designer's Choice renders the same as Front; placement note shown in UI
  designers_choice: { x: 0.25, y: 0.20, w: 0.50, h: 0.40 },
};

window.CUSTOMIZER_SIZE_MULTIPLIERS = {
  small:  0.5,
  medium: 0.75,
  large:  1.0,
  full:   1.2,
};
